import { useEffect, useState } from 'react';

export const useFacebookSDK = (appId) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // 1. Evitar ejecución si el App ID es inválido o no se ha cargado
        if (!appId || appId === 'TU_APP_ID_AQUI') {
            console.warn("⚠️ Falta el App ID de Meta. El SDK no se inicializará.");
            return;
        }

        // Función encapsulada para inicializar Meta
        const initFB = () => {
            window.FB.init({
                appId: appId, 
                cookie: true,
                xfbml: true,
                version: 'v21.0' 
            });
            setIsLoaded(true);
        };

        // 2. Si window.FB ya existe (ej. recargas en caliente de React)
        if (window.FB) {
            // Evitamos llamar a init() múltiples veces usando un flag personalizado
            if (!window.isFbInitialized) {
                initFB();
                window.isFbInitialized = true;
            } else {
                setIsLoaded(true);
            }
            return;
        }

        // 3. Si no existe, preparamos el terreno para cuando el script termine de descargar
        window.fbAsyncInit = () => {
            initFB();
            window.isFbInitialized = true;
        };

        // 4. Inyección asíncrona del script oficial
        (function(d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/es_LA/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }, [appId]);

    return isLoaded;
};